import React from 'react';
import Footer from '../Footer/Footer';
import type { HeaderProps } from '../components/Header';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Header from '../components/Header';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  footer: {
    flexShrink: 0,
  },
}));

// dev-694のタスクで以前からあるコンポーネント
// src/front/Layout/BaseLayout.tsxはこのコンポーネントをベースに作成
// RailsのSSRに依存しないフロントを作成する場合、上記ファイルのコンポーネントを使用する
const AppLayout = ({
  authenticated = false,
  notificationsCount = 0,
  imageUrl,
  isWorking,
  message,
  regions = [],
  businessCategories = [],
  children,
}: HeaderProps & {
  children: React.ReactNode,
  regions?: Array<Object>,
  businessCategories?: Array<Object>,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Header
          authenticated={authenticated}
          imageUrl={imageUrl}
          isWorking={isWorking}
          message={message}
        />
        {children}
      </div>
      <Footer
        classes={{ root: classes.footer }}
        regions={regions}
        businessCategories={businessCategories}
      />
    </div>
  );
};

export default AppLayout;
